import { iContact } from "@sdk/crm/crm.models";
import {
  getGroupContactDisplayLabel,
  isGroupContact,
} from "./is-wa-cloud-native-group";

export const getContactName = (contact: iContact) => {
  if (isGroupContact(contact)) {
    return getGroupContactDisplayLabel({ contact });
  }

  return [contact?.data.firstName, contact?.data.lastName]
    .filter((e) => e)
    .join(" ");
};
